module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Down-right-f500cf8a7a09453705b5cd7883727974.svg";